__turbopack_context__.v({
  "card": "styles-module__wmZ9dq__card",
  "cardBody": "styles-module__wmZ9dq__cardBody",
  "cardIcon": "styles-module__wmZ9dq__cardIcon",
  "cardTitle": "styles-module__wmZ9dq__cardTitle",
  "grid": "styles-module__wmZ9dq__grid",
});
